/**
 * Make reCAPTCHA badge visible and adjust the style.
 * By default the badge is hidden if the provider css is imported.
 * @returns Callback to reset.
 */ const showBadge = ()=>{
    const bodyStyle = document.createElement('style');
    bodyStyle.innerHTML = `
    .grecaptcha-badge {
      visibility: visible;
      bottom: 140px !important;
    }
  `;
    document.head.appendChild(bodyStyle);
    return ()=>{
        document.head.removeChild(bodyStyle);
    };
};

export { showBadge };
//# sourceMappingURL=controller.js.map
